import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { publicRoutes } from "./public.routes";
import { privateRoutes } from "./private.routes";
import SecureRoute from "./secure.route.wrapper";

// Recursive function to build routes from a tree-like structure
const buildRoutes = (routes, parentKey = "", isPrivate = false) => {
  return routes?.map((route, idx) => {
    const { path, element, children } = route;
    const key = `${parentKey}-${idx}`;

    const wrappedElement = isPrivate
      ? <SecureRoute>{element}</SecureRoute>
      : element;

    return (
      <Route key={key} path={path} element={wrappedElement}>
        {children && buildRoutes(children, key, isPrivate)}
      </Route>
    );
  });
};

const allRoutes = [
  ...buildRoutes(publicRoutes, "public", false),
  ...buildRoutes(privateRoutes, "private", true),
];

const navRouter = createBrowserRouter(createRoutesFromElements(allRoutes));

export default navRouter;